/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminsRouteImport } from './routes/_app/admins'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppModelsRouteImport } from './routes/_app/models'
import { Route as AppOperationsRouteImport } from './routes/_app/operations'
import { Route as AppReleasesRouteImport } from './routes/_app/releases'
import { Route as AppAccountsIndexRouteImport } from './routes/_app/accounts.index'
import { Route as AppAccountsAccountIdRouteImport } from './routes/_app/accounts.$accountId'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices.index'
import { Route as AppDevicesDeviceIdRouteImport } from './routes/_app/devices.$deviceId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsRoute = AppAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppModelsRoute = AppModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppRoute,
} as any)
const AppOperationsRoute = AppOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AppRoute,
} as any)
const AppReleasesRoute = AppReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsIndexRoute = AppAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsAccountIdRoute = AppAccountsAccountIdRouteImport.update({
  id: '/accounts/$accountId',
  path: '/accounts/$accountId',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesDeviceIdRoute = AppDevicesDeviceIdRouteImport.update({
  id: '/devices/$deviceId',
  path: '/devices/$deviceId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/sign-in': typeof SignInRoute
  '/admins': typeof AppAdminsRoute
  '/audit': typeof AppAuditRoute
  '/models': typeof AppModelsRoute
  '/operations': typeof AppOperationsRoute
  '/releases': typeof AppReleasesRoute
  '/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/accounts/': typeof AppAccountsIndexRoute
  '/devices/': typeof AppDevicesIndexRoute
}
export interface FileRoutesByTo {
  '/forbidden': typeof ForbiddenRoute
  '/sign-in': typeof SignInRoute
  '/admins': typeof AppAdminsRoute
  '/audit': typeof AppAuditRoute
  '/models': typeof AppModelsRoute
  '/operations': typeof AppOperationsRoute
  '/releases': typeof AppReleasesRoute
  '/': typeof AppIndexRoute
  '/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/accounts': typeof AppAccountsIndexRoute
  '/devices': typeof AppDevicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/sign-in': typeof SignInRoute
  '/_app/admins': typeof AppAdminsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/models': typeof AppModelsRoute
  '/_app/operations': typeof AppOperationsRoute
  '/_app/releases': typeof AppReleasesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/_app/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/_app/accounts/': typeof AppAccountsIndexRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/sign-in'
    | '/admins'
    | '/audit'
    | '/models'
    | '/operations'
    | '/releases'
    | '/accounts/$accountId'
    | '/devices/$deviceId'
    | '/accounts/'
    | '/devices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forbidden'
    | '/sign-in'
    | '/admins'
    | '/audit'
    | '/models'
    | '/operations'
    | '/releases'
    | '/'
    | '/accounts/$accountId'
    | '/devices/$deviceId'
    | '/accounts'
    | '/devices'
  id:
    | '__root__'
    | '/_app'
    | '/forbidden'
    | '/sign-in'
    | '/_app/admins'
    | '/_app/audit'
    | '/_app/models'
    | '/_app/operations'
    | '/_app/releases'
    | '/_app/'
    | '/_app/accounts/$accountId'
    | '/_app/devices/$deviceId'
    | '/_app/accounts/'
    | '/_app/devices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins': {
      id: '/_app/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AppAdminsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/models': {
      id: '/_app/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof AppModelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations': {
      id: '/_app/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AppOperationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/releases': {
      id: '/_app/releases'
      path: '/releases'
      fullPath: '/releases'
      preLoaderRoute: typeof AppReleasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts/': {
      id: '/_app/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AppAccountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts/$accountId': {
      id: '/_app/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AppAccountsAccountIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$deviceId': {
      id: '/_app/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof AppDevicesDeviceIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminsRoute: typeof AppAdminsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppModelsRoute: typeof AppModelsRoute
  AppOperationsRoute: typeof AppOperationsRoute
  AppReleasesRoute: typeof AppReleasesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountsAccountIdRoute: typeof AppAccountsAccountIdRoute
  AppDevicesDeviceIdRoute: typeof AppDevicesDeviceIdRoute
  AppAccountsIndexRoute: typeof AppAccountsIndexRoute
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminsRoute: AppAdminsRoute,
  AppAuditRoute: AppAuditRoute,
  AppModelsRoute: AppModelsRoute,
  AppOperationsRoute: AppOperationsRoute,
  AppReleasesRoute: AppReleasesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountsAccountIdRoute: AppAccountsAccountIdRoute,
  AppDevicesDeviceIdRoute: AppDevicesDeviceIdRoute,
  AppAccountsIndexRoute: AppAccountsIndexRoute,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
